export default __webpack_public_path__ + "static/media/top-pattern.a929102b.svg";